import React from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./style/tokens.css";
import "./style/output.css";
import { ThemeModeProvider } from "./theme/ThemeModeProvider.jsx";

import { Provider, useSelector } from "react-redux";
import { persistor, store } from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeModeProvider>
          <App />
        </ThemeModeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker : app installable, mise en cache de l'app shell. Actif en production seulement.
serviceWorkerRegistration.register();

// Recharge la page UNE FOIS quand une nouvelle version du service worker prend la main
// (service-worker.js appelle désormais skipWaiting() dès l'installation, sans attendre la
// fermeture de tous les onglets) — sinon la page resterait pilotée par le nouveau service
// worker tout en exécutant encore l'ancien code JS déjà chargé. `dejaRecharge` évite une
// boucle si "controllerchange" se déclenche plusieurs fois.
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  let dejaRecharge = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (dejaRecharge) return;
    dejaRecharge = true;
    window.location.reload();
  });
}

// Pastille numérotée sur l'icône de l'app (Badging API, 28/09/2026) : dès que
// l'utilisateur revient sur l'application, on considère qu'il a vu ce qui
// l'attendait — la cloche et les actualités reprennent la main sur leur
// propre badge « non lu » à l'écran. Feature-detecté, jamais bruyant sur un
// navigateur qui ne connaît pas l'API (Firefox, Safari hors PWA installée).
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && navigator.clearAppBadge) {
      navigator.clearAppBadge().catch(() => {});
    }
  });
}
